/* Trellis Bliss: product card wishlist, quantity and buy-now handlers (one cached file instead of a copy per card) */
(function() {
  var WISHLIST_KEY = 'tb_wishlist_items';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    } catch(e) {}
    updateWishlistBadges();
  }

  function updateWishlistBadges() {
    var list = getWishlist();
    var count = list.length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function(b) {
      b.textContent = count;
      if (count > 0) {
        b.classList.remove('hidden');
      } else {
        b.classList.add('hidden');
      }
    });
  }

  function updateHeartVisual(btn, active) {
    if (active) {
      btn.classList.add('active');
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill', '#123620');
        var path = svg.querySelector('path');
        if (path) path.setAttribute('fill', '#123620');
      }
    } else {
      btn.classList.remove('active');
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill', 'none');
        var path = svg.querySelector('path');
        if (path) path.setAttribute('fill', 'none');
      }
    }
  }

  function syncWishlistButtons() {
    var list = getWishlist();
    var ids = list.map(function(item) {
      return typeof item === 'object' ? String(item.id) : String(item);
    });

    var buttons = document.querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(function(btn) {
      var pid = String(btn.getAttribute('data-product-id'));
      updateHeartVisual(btn, ids.indexOf(pid) !== -1);
    });
  }

  function toggleWishlist(btn) {
    var pid = String(btn.getAttribute('data-product-id'));
    var title = btn.getAttribute('data-product-title');
    var handle = btn.getAttribute('data-product-handle');
    var url = btn.getAttribute('data-product-url');
    var img = btn.getAttribute('data-product-img');
    var price = btn.getAttribute('data-product-price');

    var list = getWishlist();
    var index = -1;
    for (var i = 0; i < list.length; i++) {
      var id = typeof list[i] === 'object' ? String(list[i].id) : String(list[i]);
      if (id === pid) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      list.splice(index, 1);
      updateHeartVisual(btn, false);
    } else {
      list.push({
        id: pid,
        title: title,
        handle: handle,
        url: url,
        img: img,
        price: price
      });
      updateHeartVisual(btn, true);
    }

    setWishlist(list);
  }

  function initWishlistAndVariants() {
    syncWishlistButtons();
    updateWishlistBadges();

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn);
    }, true);

    document.addEventListener('change', function(e) {
      var select = e.target.closest('[data-variant-select-dropdown]');
      if (!select) return;

      var card = select.closest('.custom-collection-card');
      if (!card) return;

      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      var variantId = select.value;
      var price = opt.getAttribute('data-price');
      var comparePrice = opt.getAttribute('data-compare-price');
      var discount = opt.getAttribute('data-discount');
      var available = opt.getAttribute('data-available') !== 'false';
      var text = opt.text ? opt.text.trim() : '';

      var label = card.querySelector('[data-selected-size-label]');
      if (label && text) label.textContent = text;

      var imageSrc = opt.getAttribute('data-image');
      if (imageSrc) {
        var cardImg = card.querySelector('.custom-card-img, [data-product-card-img]');
        if (cardImg) {
          cardImg.src = imageSrc;
          if (cardImg.hasAttribute('srcset')) {
            cardImg.removeAttribute('srcset');
          }
        }
      }

      var input = card.querySelector('[data-variant-input-id]');
      if (input && variantId) input.value = variantId;

      var priceDisplay = card.querySelector('[data-variant-price-display]');
      if (priceDisplay && price) priceDisplay.textContent = price;

      var compareDisplay = card.querySelector('[data-variant-compare-display]');
      if (compareDisplay) {
        if (comparePrice) {
          compareDisplay.textContent = comparePrice;
          compareDisplay.style.display = 'inline-block';
        } else {
          compareDisplay.textContent = '';
          compareDisplay.style.display = 'none';
        }
      }

      var discountDisplay = card.querySelector('[data-variant-discount-display]');
      if (discountDisplay) {
        if (discount) {
          discountDisplay.textContent = discount;
          discountDisplay.style.display = 'inline-block';
        } else {
          discountDisplay.textContent = '';
          discountDisplay.style.display = 'none';
        }
      }

      var submitBtn = card.querySelector('[data-variant-submit-btn]');
      var submitText = card.querySelector('[data-submit-btn-text]');
      var buyNowBtn = card.querySelector('[data-variant-buynow-btn]');
      if (submitBtn && submitText) {
        submitText.textContent = 'ADD TO CART';
        submitBtn.classList.remove('out-of-stock');
      }
      if (buyNowBtn) {
        buyNowBtn.classList.remove('hidden');
      }
    }, true);
  }

  if (window.customWishlistInitialized === undefined) {
    window.customWishlistInitialized = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWishlistAndVariants);
    } else {
      initWishlistAndVariants();
    }
  }
})();

(function() {
  function initQuantitySwitcher() {
    document.body.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      
      var change = parseInt(btn.getAttribute('data-qty-change'));
      var container = btn.closest('[data-qty-container]');
      if (!container) return;
      
      var input = container.querySelector('[data-qty-input]');
      if (!input) return;
      
      var currentVal = parseInt(input.value) || 1;
      var newVal = currentVal + change;
      if (newVal < 1) newVal = 1;
      input.value = newVal;
    });
  }
  
  if (window.customQuantityListenerInitialized === undefined) {
    window.customQuantityListenerInitialized = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuantitySwitcher);
    } else {
      initQuantitySwitcher();
    }
  }
})();

(function() {
  function initAjaxAddToCart() {
    // Intercept BUY NOW button clicks directly and checkout with GoKwik
    document.addEventListener('click', function(e) {
      var buyBtn = e.target.closest('.custom-card-btn-buy, [data-variant-buynow-btn]');
      if (!buyBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var form = buyBtn.closest('form');
      if (!form) return;

      var variantInput = form.querySelector('[data-variant-input-id]') || form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[data-qty-input]') || form.querySelector('[name="quantity"]');

      var variantId = variantInput ? variantInput.value : '';
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) return;

      if (typeof window.triggerGokwikBuyNow === 'function') {
        window.triggerGokwikBuyNow(variantId, quantity, buyBtn);
      } else {
        buyBtn.style.opacity = '0.7';
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
            });
          })
          .then(function() {
            if (typeof window.triggerGokwikCustomCheckout === 'function') {
              window.triggerGokwikCustomCheckout();
            } else if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
              window.gokwikSdk.initCheckout(window.merchantInfo);
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function(err) {
            console.error('BUY NOW error:', err);
            window.location.href = '/checkout';
          });
      }
    }, true);

    // Intercept ADD TO CART button submits and open Cart Drawer
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.custom-card-form');
      if (!form) return;
      
      if (e.submitter && (e.submitter.getAttribute('name') === 'checkout' || e.submitter.classList.contains('custom-card-btn-buy'))) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      var variantInput = form.querySelector('[data-variant-input-id]');
      var qtyInput = form.querySelector('[data-qty-input]');

      var variantId = variantInput ? variantInput.value : '';
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) return;

      var btn = form.querySelector('[data-variant-submit-btn]');
      if (btn) btn.style.opacity = '0.7';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (btn) btn.style.opacity = '1';
        if (window.openCustomCartDrawer) {
          window.openCustomCartDrawer();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function(err) {
        console.error('AJAX add to cart error:', err);
        if (btn) btn.style.opacity = '1';
      });
    }, true);
  }

  if (window.customAjaxCartInitialized === undefined) {
    window.customAjaxCartInitialized = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAjaxAddToCart);
    } else {
      initAjaxAddToCart();
    }
  }
})();
